const CANNABIS_API_URL =
  "https://raw.githubusercontent.com/Piyush-Bhor/The_Cannabis_API/v2/cannabis.json";

let cachedData = null;

export async function fetchStrains() {
  if (cachedData) return cachedData;
  const res = await fetch(CANNABIS_API_URL);
  if (!res.ok) throw new Error("Failed to fetch cannabis data");
  cachedData = await res.json();
  return cachedData;
}

// Derived helpers
export async function getTypes() {
  const strains = await fetchStrains();
  return [...new Set(strains.map((s) => s.Type).filter(Boolean))].sort();
}

export async function getEffects() {
  const strains = await fetchStrains();
  const all = strains.flatMap((s) => s.Effects?.split(",") ?? []);
  return [...new Set(all.map((e) => e.trim()).filter(Boolean))].sort();
}

export async function getStrainsByType(type) {
  const strains = await fetchStrains();
  return type ? strains.filter((s) => s.Type === type) : strains;
}